<script setup lang="ts">
import { ref } from 'vue';

const email = 'kontakt@cv-tailor.ai';
const copied = ref(false);

const copyEmail = async () => {
  try {
    await navigator.clipboard.writeText(email);
    copied.value = true;
    setTimeout(() => {
      copied.value = false;
    }, 1500);
  } catch {
    copied.value = false;
  }
};
</script>

<template>
  <footer class="bg-slate-900 text-slate-400 py-12">
    <div class="max-w-7xl mx-auto px-4 text-center">
      <p class="mb-4 text-slate-200 font-bold text-xl">CV-Tailor AI</p>
      <div class="mb-5">
        <p class="text-slate-200 font-semibold mb-2">Masz pytania? Skontaktuj się z nami</p>
        <div class="flex items-center justify-center gap-3 flex-wrap">
          <a
            :href="`mailto:${email}`"
            class="text-slate-100 underline underline-offset-4 hover:text-white transition"
          >
            {{ email }}
          </a>
          <button
            type="button"
            class="px-3 py-1.5 text-sm rounded-lg border border-slate-700 text-slate-200 hover:bg-slate-800 transition"
            @click="copyEmail"
          >
            Kopiuj
          </button>
        </div>
        <p v-if="copied" class="text-xs text-slate-300 mt-2">Skopiowano adres e-mail</p>
      </div>
      <p>© 2024 CV-Tailor AI. Wszystkie prawa zastrzeżone.</p>
    </div>
  </footer>
</template>
